export default [
  {
    label: '自定义Logo',
    type: 'Input',
    key: 'logoImage',
    tip: '默认尺寸200px*50px',
    labelStyle: {
      fontWeight: 'bold',
    },
  },
  {
    label: 'Logo大小',
    type: 'InputPercent',
    key: 'logoImageWidth',
    tip: '填写宽度百分比，例如30%',
    labelStyle: {
      fontWeight: 'bold',
    },
  },
];
